module.exports = __webpack_public_path__ + "img/schneider.c34582a9.png";